import { createRouter, createWebHashHistory } from 'vue-router';

// Import the views
import HomePage from '../js/VueComponents/Views/Home.vue';
import RegistrationPage from '../js/VueComponents/Views/Registration.vue';

// Define your routes
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/Index',
    name: 'Index',
    component: HomePage
  },
  {
    path: '/Registration',
    name: 'Registration',
    component: RegistrationPage
  }
];

// Create the Vue Router instance
const router = createRouter({
  history: createWebHashHistory(),  // Use history mode (clean URLs)
  routes
});

export default router;
